var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32844)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#A71435"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.04969 2.9509C7.43996 2.26135 9.02617 2.0747 10.5385 2.42271C12.0509 2.77071 13.396 3.63188 14.345 4.85972C15.2941 6.08757 15.7885 7.60628 15.7442 9.15752C15.6999 10.7088 15.1195 12.1968 14.1019 13.3684C13.7672 12.6394 13.5107 11.875 13.2238 11.1223L11.4913 6.58296C11.3243 6.12283 11.0436 5.68071 10.6076 5.44165C9.99723 5.14737 9.31311 5.04125 8.64225 5.13677C8.1045 5.19696 7.54312 5.38202 7.17862 5.80615C6.83212 6.20608 6.67687 6.72021 6.48 7.20396L5.23125 10.3697C4.81331 11.3732 4.46062 12.4127 4.00669 13.41C3.35283 12.7038 2.87233 11.8551 2.60325 10.9311C2.13826 9.40667 2.23019 7.76662 2.86262 6.30372C3.49505 4.84082 4.62682 3.6503 6.05587 2.94471L6.04969 2.9509Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.54663 7.52631C8.66588 7.16799 9.14401 7.04818 9.45451 7.25181C9.62157 7.37724 9.68176 7.59212 9.75938 7.78337C10.5356 9.81399 11.3006 11.857 12.0713 13.8944C12.1725 14.1869 12.3216 14.4676 12.3818 14.7719C12.3329 14.824 12.2763 14.8683 12.2141 14.9035C11.3713 15.3544 10.4422 15.6207 9.48853 15.6846C8.53484 15.7485 7.57848 15.6086 6.68307 15.2742C6.34838 15.1364 6.00244 15.0171 5.70938 14.8079C5.73919 14.5334 5.87644 14.2881 5.97826 14.0372C6.83832 11.8694 7.68038 9.69474 8.54663 7.52631Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32844"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArg);
export default __webpack_public_path__ + "static/media/arg.93ad4be64e53dce72d617093ef9d3972.svg";
export { ForwardRef as ReactComponent };